import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito comprar herramientas caras?',
  answer: 'No, el 90% del método se basa en cambios en tu comportamiento.'
}, {
  question: '¿Qué pasa si mi perro es viejo?',
  answer: 'Nunca es tarde para reprogramar un hábito de ansiedad.'
}, {
  question: '¿Es seguro para cachorros?',
  answer: 'Es el mejor momento para aplicarlo y prevenir problemas crónicos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 bg-cream-100" data-id="element-26">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="text-center mb-8 md:mb-12" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal" data-id="element-29">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white rounded-2xl border border-cream-200 overflow-hidden shadow-sm" data-id="element-31">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-32">
                  <span className="text-lg font-bold text-charcoal pr-8" data-id="element-33">
                    {faq.question}
                  </span>
                  <div className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-amber-100 text-amber-600' : 'bg-cream-100 text-charcoal-light'}`} data-id="element-34">
                    {isOpen ? <MinusIcon size={18} data-id="element-35" /> : <PlusIcon size={18} data-id="element-36" />}
                  </div>
                </button>
                <AnimatePresence data-id="element-37">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-38">
                      <div className="px-6 pb-5 text-charcoal-light leading-relaxed" data-id="element-39">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}